import { Validator } from '@utils/validations/validation.type';

export const max: Validator = ({ value, maxValue, message }: { value: number; maxValue: number; message: string }) => {
  if (!maxValue) return undefined;

  const isValid = +value <= +maxValue;
  return isValid ? undefined : message;
};
